import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import storage from "../../../../firebaseConfig.js"
import {ref,uploadBytesResumable, getDownloadURL} from "firebase/storage"
import {
  Button,
  Avatar,
  TextField,
  Paper,
  Typography,
  Grid,
  Box,

} from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress';

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import IconButton from "@material-ui/core/IconButton";
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {

  KeyboardDatePicker,
} from '@material-ui/pickers';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import AddIcon from '@material-ui/icons/Add';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { NetworkContext } from '../../../../context/NetworkContext';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  papercontent: {
      marginTop : theme.spacing(2),
      textAlign : 'center'
  },
  drawer: {
    width: 420,
    maxWidth: '100%'
  },
  descriptionfield: {
    width: '100%'
   
  },
  header: {
    padding: theme.spacing(2, 1),
    display: 'flex',
    justifyContent: 'space-between'
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  content: {
    padding: theme.spacing(2, 3),
    flexGrow: 1
  },
  contentSection: {
    padding: theme.spacing(2, 0)
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionContent: {},
  formGroup: {
   
    padding: theme.spacing(1, 0)
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  field: {
    marginTop: 0,
    marginBottom: 0
  },
  flexGrow: {
    flexGrow: 1
  },
  input: {
    display: 'none',
  },
  addButton: {
    marginLeft: theme.spacing(1)
  },
  tags: {
    marginTop: theme.spacing(1)
  },
  minAmount: {
    marginRight: theme.spacing(3)
  },
  maxAmount: {
    marginLeft: theme.spacing(3)
  },
  radioGroup: {},
  actions: {
    textAlign: 'right',
    padding: theme.spacing(3),
    paddingRight: theme.spacing(5),
    '& > * + *': {
      margin: theme.spacing(0)
    }
  }
}));
function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};
const ProductDetails = props => {
  const { open, onClose, onUpdate,usercontent,masters, viewtype, className, ...rest } = props;

  const classes = useStyles();
  const [basicInfo, setBasicInfo] = React.useState({});
  const [percent, setPercent] = React.useState(0);
  const [masterlanguages, setMasterLanguages] = React.useState([]);
  const [selectedlangs, setSelectedlangs] = React.useState([]);

  const produtoptions = {
    options:[
                
               
      {
        "id":1,
        "name":"Broker 1",
        "createdAt":"17 Nov 2022 10:20 AM",
        "status":true
      },
      {
        "id":2,
        "name":"Broker 2",
        "createdAt":"17 Nov 2022 10:20 AM",
        "status":true
      },
      {
        "id":3,
        "name":"Broker 3",
        "createdAt":"17 Nov 2022 10:20 AM",
        "status":true
      }
    ],
    getOptionLabel: (option) => option.name
  
  };
  const [movies, setMovies] = useState([]);

  const initialValues = {
    languages:['All','Tamil','English','Telugu'],
    nameenglish: '',
    nametamil:'',
    nametelugu:'',
    descenglish:'',
    desctamil:'',
    desctelugu:'',
    qty : '',
    producttype: {},
    imageurl:'',
    commodity: [],
    subcommodity : []
  };
  const { sendNetworkRequest } = React.useContext(NetworkContext);

  const [expandProject, setExpandProject] = useState(true);
  const [expandCustomer, setExpandCustomer] = useState(false);
  const [subcommodity, setSubcommodity] = useState([]);
  const [error, setError] = React.useState({error: false,
    message: {
      
    }});
  const [values, setValues] = useState({
    ...initialValues
  });

  const handleClear = () => {
    setValues({ ...initialValues });
  };


  React.useEffect(() => {
    if(masters.languages)
    {
      let langs_arr = [...masters.languages]
      langs_arr.splice(0,1)
      setMasterLanguages([
        ...langs_arr
      ])
      if(viewtype==2)
      {
        masters['languages'] = [
          
          ...langs_arr
        ]
      
      }
    }
  },[masters])
 
  React.useEffect(() => {
    if(usercontent && usercontent.languages)
    {
      let commodities = [];
      let sub_commodities = [];
      let commodityids = []
      let langs = [];
      let prod_coms = usercontent?.product_commodities
      
      let prod_langs = usercontent.product_languages;
      prod_coms.map(ele => {
        if(ele.parent_commodity_id == null)
        {
          commodities.push(ele.master_commodity)
        }else {
          sub_commodities.push(ele.master_commodity)
        }
      })
      fetchsubcommodity(commodities);

      prod_langs.map(ele => {
        langs.push(ele.master_language)
      })
      setSelectedlangs(langs)
      setValues({
        ...usercontent,
        commodity : commodities,
        subcommodity : sub_commodities,
        language : langs
      })
    }
 }, [usercontent]);
  const handleFieldChange = (event, field, value) => {
    event.persist && event.persist();
    setValues(values => ({
      ...values,
      [field]: value
    }));
  };

  const handleTagAdd = () => {
    setValues(values => {
      const newValues = { ...values };

      if (newValues.tag && !newValues.tags.includes(newValues.tag)) {
        newValues.tags = [...newValues.tags];
        newValues.tags.push(newValues.tag);
      }

      newValues.tag = '';

      return newValues;
    });
  };

  const handleTagDelete = tag => {
    setValues(values => {
      const newValues = { ...values };

      newValues.tags = newValues.tags.filter(t => t !== tag);

      return newValues;
    });
  };

  const handleToggleProject = () => {
    setExpandProject(expandProject => !expandProject);
  };

  const handleToggleCustomer = () => {
    setExpandCustomer(expandCustomer => !expandCustomer);
  };

  const handleSubmit = event => {
    event.preventDefault();
    let iserror = false
    let messagecontent = {}
    if(!values.language || values.language.length == 0)
    {
      iserror = true
      messagecontent['language'] = "Please enter choose atleast one language"
    }else{
      let langs =  [
        ...selectedlangs
      ]
    
      if(values.language.length == 1)
      {
        if(values.language[0].name === 'All')
        {
          langs = [
            ...selectedlangs
          ]

      // langs.splice(0,1)
        }
      }
      langs.map((element,index) => {
       
        if(!values['name-'+element.name])
        {
          iserror = true
         messagecontent['name-'+element.name] = `Please enter ${element.name} title`
        }

       
      
      })
    }
    if(!values.commodity || values.commodity.length == 0)
    {
      iserror = true
      messagecontent['commodity'] = "Please enter choose atleast one commodity"
    }
    if(!values.imageurl || values.imageurl.length == 0)
    {
      iserror = true
      messagecontent['imageurl'] = "Please add image"
    }
    if(!values.qty || values.qty.length == 0)
    {
      iserror = true
      messagecontent['qty'] = "Please add qty"
    }
    
    values['languages'] = masterlanguages
    values['language'] = selectedlangs

    if(iserror)
    {
    let errorcontent = {
      error : true,
      message : messagecontent
    }

    setError(errorcontent)
  }else{
    let errorcontent = {
      error : false,
      message : messagecontent
    }
    setError(errorcontent)
    onUpdate && onUpdate(values);
  }
    
  };

  const paymentStatusOptions = ['Pending', 'Canceled', 'Completed', 'Rejected'];
  const customerAgeOption = ['18 - 30', '30 - 45', '50 - 60', '60+'];
  const handleChange = (event) => {
    if(event.target.value == 'All')
    {
      if(event.target.checked)
      {
        setValues(values => ({
          ...values,
          ['languages']: ['All','Tamil','English','Telugu']
        }));
      }else{
        setValues(values => ({
          ...values,
          ['languages']: []
        }));
      }
    }else{
      if(event.target.checked)
      {
        var array = [...values.languages]
        if(array.length === 2)
        {
          array.push('All')
        }
        array.push(event.target.value)
        setValues(values => ({
          ...values,
          ['languages']: array
        }));
      }else{
        var array = [...values.languages]; // make a separate copy of the array
         if(array.length > 1)
         {
          var allindex = array.indexOf('All')
          if(allindex !== -1)
          {
            array.splice(allindex, 1)
          }

          var index = array.indexOf(event.target.value)
          if (index !== -1) {
            array.splice(index, 1);
           
            setValues(values => ({
              ...values,
              ['languages']: array
            }));
          }
        }
      }
    }
    //setChecked(event.target.checked);
  };

  const handleoptionchange = type => (event, value) => {
  
    if(type === 'language' && value.length > 0 && value[0].name === 'All')
    {
      let langs = [];

      masters.languages.map((element)=> {
        if(element.name != 'All')
        {
          langs.push(element)

        }
      })
      setSelectedlangs([...langs])
      masters['languages'] = [
        {
          id : 0,
          name : "All"
        }
      ]

      setValues(values => ({
        ...values,
        [type]: value
      }));
    
    }else {
      if(type === 'language')
      {
        if(value.length > 0)
        {
          setSelectedlangs([...value])
  
          masters['languages'] = [
            ...masterlanguages
          ]
        }else{
          masters['languages'] = [
            {
              id : 0,
              name : "All"
            },
            ...masterlanguages
          ]
          setSelectedlangs([])
        }
      }
    if(type == 'commodity')
    {
      if(value)
      {
        // let change_commodities = values.commodity.length > 0 ? values.commodity : []
        // change_commodities.push(value)
        fetchsubcommodity(value)
        
      }else{
        setSubcommodity([])
        setValues(values => ({
          ...values,
          [subcommodity]: null
        }));
      }
    }
    setValues(values => ({
      ...values,
      [type]: value
    }));
  }
  }
  const setData = async (value, name, fun, state) => {
    let url = null;
    let extra = {};
    if (name === "image") {
      if (!value) {
        alert("Please choose a file first!")
        }

        const storageRef = ref(storage, `/product/${value.name}`)
        const uploadTask = uploadBytesResumable(storageRef, value);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
          const percent = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          
          // update progress
          setPercent(percent);
          },
          (err) => console.log(err),
          () => {
          // download url
          getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            console.log("imageurl"+url)
            setValues(values => ({
              ...values,
              ['imageurl']: url
            }));
          });
          }
          );
     
    }

    fun({
      ...state, [name]: value, ...extra
    })
  }


  const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });


  const handleinputchange = type => e => {
    setValues({
      ...values,
      [type]: e.target.value
    });
  }
  async function fetchsubcommodity(commodityID)
  {
    let post_commodities = [];
    commodityID.map(item => {
      post_commodities.push(item.id)
    })
    let bodycontent = {
     parent_id : post_commodities
    }

    let commodity_arr = await sendNetworkRequest('/admin/getmultiplesubcommodity', {}, bodycontent,false)
    setSubcommodity(commodity_arr.module)
  }
  return (
  <Paper className={classes.papercontent}> 
      <form
        {...rest}
        className={clsx(classes.root, className)}
        onSubmit={handleSubmit}
      >
        
        <div className={classes.content}>
        <Grid container row xs={12}>
        
          <Grid container xs={9} spacing={2}>
          <Grid item xs={12}>
          {masters.languages && (values.language || viewtype == 1)  && <Autocomplete
              multiple
              id="combo-box-demo"
              options={masters.languages}
              margin="dense"
              fullWidth
              value={values.language}
              onChange={handleoptionchange('language')}
              getOptionSelected={(option, value) => option.name === value.name}
                  filterSelectedOptions
              getOptionLabel={(option) => option.name}
              renderInput={(params) => <TextField {...params} label={"Languages"} 
              error={error?.message?.language}
              helperText={error?.message?.language}
              fullWidth margin="dense" variant="outlined" />}
            /> 
          }
        </Grid>
         
          <Grid item xs={12}>
            <Autocomplete

                  id="combo-box-demo"
                  options={masters.commodity}
                  margin="dense"
                  fullWidth
                  multiple
                  //disabled={viewtype == 2 ? true : false}
                  onChange={handleoptionchange('commodity')}
                  value={values && values.commodity}
                  getOptionLabel={(option) => option.name}
                  getOptionSelected={(option, value) => option.name === value.name}
                  filterSelectedOptions
                  renderInput={(params) => <TextField {...params} label={"Commodity"} 
                  error={error?.message?.commodity}
                  helperText={error?.message?.commodity}
                  fullWidth margin="dense" variant="outlined" />}
                /> 
            </Grid> 
            <Grid item xs={12}>
            <Autocomplete
                  id="combo-box-demo"
                  options={subcommodity}
                  margin="dense"
                  fullWidth
                  multiple
                  value={values.subcommodity}
                  onChange={handleoptionchange('subcommodity')}
                  getOptionSelected={(option, value) => option.id === value.id}
                  filterSelectedOptions
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => <TextField {...params} label={"Sub Commodity"} fullWidth margin="dense" variant="outlined" />}
                /> 
            </Grid> 
            {selectedlangs != null && selectedlangs.map((order,index)  => (
            <Grid item xs={12}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                          //  disabled={viewtype == 2 ? true : false}
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                            error={error?.message?.['name-'+order.name]}
                                helperText={error?.message?.['name-'+order.name]}
                            value={values['name-'+order.name]}
                            onChange={handleinputchange('name-'+order.name)}
                           label={"Product Name ("+order.name+ "*)"}
                          />
            </Grid>))}
                    <Grid item xs={12}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                            onChange={handleinputchange('qty')}
                            value={values.qty}
                            error={error?.message?.qty}
                            helperText={error?.message?.qty}
                           label="Quantity"
                          />
                      </Grid>
            <Grid item xs={12}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                           label="Image Url"
                           error={error?.message?.imageurl}
                  helperText={error?.message?.imageurl}
                          // disabled={viewtype == 2 ? true : false}
                           onChange={handleinputchange('imageurl')}
                           value={values.imageurl}
                           
                           
                          />
            </Grid>
            
            
         
          
          
          </Grid>
          <Grid container xs={3}>
          <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  spacing={2}
                  style={{ display: "grid" }}
                >
                  <Grid style={{ margin: "auto" }}>
                    <input accept="image/*" className={classes.input} id="icon-button-file" type="file"
                      onChange={e => setData(e.target.files[0], "image", setBasicInfo, basicInfo)}
                    />
                   {values.imageurl ? <label htmlFor="icon-button-file">
                      <Avatar src={values.imageurl} style={{ width: 140, height: 140, borderRadius: 10, cursor: "pointer" }} />
                    </label> : <label htmlFor="icon-button-file">
                      <Avatar src={values.imageurl} style={{ width: 140, height: 140, borderRadius: 10, cursor: "pointer" }} />
                    </label>}
                    {percent == 0 || percent == 100 && <LinearProgressWithLabel value={percent} />}
                  </Grid>
                </Grid>
                </Grid>
          </Grid>
        </div>
        <div className={classes.actions}>
          {/* <Button
            onClick={handleClear}
            variant="contained"
           
          >
            Clear
          </Button> */}
          <Button
            color="primary"
            type="submit"
            variant="contained"
          >
            Update
          </Button>
        </div>
      </form>
      </Paper> 
  );
};

ProductDetails.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onUpdate: PropTypes.func,
  open: PropTypes.bool.isRequired,
  masters: PropTypes.object
};

export default ProductDetails;
